import { Typography } from 'antd'

export const ListGoodsNamesRender = (value?: string) => {
  return (
    <Typography.Text
      style={{ maxWidth: 400 }}
      ellipsis={{
        tooltip: {
          title: value,
          placement: 'right',
          styles: {
            container: {
              maxHeight: 400,
              overflowY: 'auto'
            }
          }
        }
      }}
    >
      {value}
    </Typography.Text>
  )
}
